import React from "react";
import Alert from 'react-bootstrap/Alert'
import DatePicker from "react-datepicker";
import { setKey } from '../../api/insurance-takers/actions'
import { setInfoKey } from '../../api/information-collection/actions'
import FileUploader from '../file-uploader';
import moment from "moment";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import is from 'date-fns/locale/is';
import { Tooltip, getPortfolios,ssnIsUSABorn } from "../../utils";
import CitizenshipModal from "../modals/citizenship-modal";
import { Link } from 'react-router-dom'
import { nationalRegistry } from "../../api/national-registry/reducers";
registerLocale('is', is)


class TaxInfoCollection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                cityOfBirth: '',
                occupation: '',
                tinOrSsn: '',
                tinOrSsnInsured: ''
            },
            initialOccupation: null
        }
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.multipleCitizenshipsAnswerNo = this.multipleCitizenshipsAnswerNo.bind(this)
        this.onChangeDate = this.onChangeDate.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onChangeSelectCustomerValue = this.onChangeSelectCustomerValue.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickToggle = this.onClickToggle.bind(this)
        this.onClickSubmitLater = this.onClickSubmitLater.bind(this)
        this.validateForm = this.validateForm.bind(this)
        this.cityOfBirth = React.createRef()
        this.occupation = React.createRef()
        this.tinOrSsn = React.createRef()
        this.tinOrSsnInsured = React.createRef()
    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        let today = moment.utc(new Date());
        let inOneMonth = moment.utc(today).add(1, 'M');

        Object.keys(errors).forEach(key => {
            switch (key) {
                case 'cityOfBirth':
                    let cityOfBirthValue = this.cityOfBirth.current.value
                    if (cityOfBirthValue === '') {
                        errors.cityOfBirth = 'Skilyrði að fylla út'
                        valid = false;
                    }
                    else {
                        errors.cityOfBirth = ''
                    }
                    break;
                case 'occupation':
                    if (this.state.initialOccupation === null) {
                        let occupationValue = this.occupation.current.value
                        if (occupationValue === '0') {
                            errors.occupation = 'Skilyrði að fylla út'
                            valid = false;
                        }
                        else {
                            errors.occupation = ''
                        }
                    }
                    break;
                case 'tinOrSsn':
                    errors.tinOrSsn = ''
                    if (this.props.initialValues.connectionUSA && !this.props.initialValues.tinOrSsnSubmitLater) {
                        try {
                            let tinOrSsnValue = this.tinOrSsn.current.value
                            if (tinOrSsnValue === '') {
                                errors.tinOrSsn = 'Skilyrði að fylla út'
                                valid = false;
                            } else if  (!/[0-9]{9}/.test(tinOrSsnValue)) {
                                errors.tinOrSsn = 'Vinsamlegast sláðu inn gilt TIN/SSN númer (9 tölustafir)';
                                valid = false;
                            }
                        } catch (e) {
                            valid = false;
                        }
                    }
                    break;
                case 'tinOrSsnInsured':
                    errors.tinOrSsnInsured = ''
                    if (this.props.initialValues.connectionToUSAInsured && !this.props.initialValues.tinOrSsnInsuredSubmitLater) {
                        try {
                            let tinOrSsnInsuredValue = this.tinOrSsnInsured.current.value
                            if (tinOrSsnInsuredValue === '') {
                                errors.tinOrSsnInsured = 'Skilyrði að fylla út'
                                valid = false;
                            } else if  (!/[0-9]{9}/.test(tinOrSsnInsuredValue)) {
                                errors.tinOrSsnInsured = 'Vinsamlegast sláðu inn gilt TIN/SSN númer (9 tölustafir)';
                                valid = false;
                            }
                        } catch (e) {
                            valid = false;
                        }
                    }
                    break;
                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value === "false" ? false : true }, this.props.insuranceTaker))
    }

    multipleCitizenshipsAnswerNo(event) {
        this.props.dispatch(setKey({ key: 'citizenships', value: '' }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value === "false" ? false : true }, this.props.insuranceTaker))
    }

    onChangeTextInput(event) {
        // this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.insuranceTaker))
    }

    onChangeDate(id, date) {
        this.props.dispatch(setKey({ key: id, value: date }, this.props.insuranceTaker))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.insuranceTaker))
    }

    onChangeSelectCustomerValue(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.insuranceTaker))
    }

    onClickConfirm(event) {
        let validate = this.validateForm()

        if (validate) {
            this.props.dispatch(setKey({ key: event.target.name, value: true }, this.props.insuranceTaker))
            this.props.successCallback()
        } else {
            this.props.dispatch(setKey({ key: event.target.name, value: false }, this.props.insuranceTaker))
        }
    }

    onClickChange(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: false }, this.props.insuranceTaker))
    }

    onClickToggle(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: !this.props.initialValues[event.target.name] }, this.props.insuranceTaker))
    }

    onClickSubmitLater(event) {
        if (event.target.name == "tinOrSsnSubmitLater") {
            this.props.dispatch(setKey({ key: "tinOrSsn", value: ""}, this.props.insuranceTaker));
        } else {
            this.props.dispatch(setKey({ key: "tinOrSsnInsured", value: ""}, this.props.insuranceTaker));
        }
        this.onClickToggle(event);
    }

    componentDidMount() {
        const { initialValues, nationalRegistry, isFORorFORE, onlyRISLEB } = this.props
        if ((getPortfolios(this.props).indexOf('komfortdynamik') !== -1) &&
            initialValues.connectionUSA) {
                initialValues.taxInfoConfirm = false
            }
        if (!onlyRISLEB && isFORorFORE && nationalRegistry.BirthplaceCountryId == 'US' && !initialValues.connectionToUSAInsured) {
            this.props.dispatch(setKey({ key: 'connectionToUSAInsured', value: true }, this.props.insuranceTaker))
        }
    }


    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip({ html: true })
    }

    usaTextContent() {
        return "<strong>Með sérstakri tengingu við Bandaríkin er átt við:</strong><ul><li>Bandarískt ríkisfang, þar með talið tvöfalt ríkisfang</li><li>Aðalbúsetu í Bandaríkjunum eða að lágmarki í 183 daga undanfarin þrjú ár<li>Handhafi varanlegs dvalar- og atvinnuleyfis í Bandaríkjunum (t.d. Græna kortið)<li>Skattskylda í Bandaríkjunum (t.d. tvöföld búseta eða samsköttun með bandarískum einstaklingi)<li>Fædd(ur) í Bandaríkjunum<li><strong>Undantekning:</strong> Ef það er skattskylda í Bandaríkjunum af öðrum ástæðum, svo sem vegna:<ul><li>viðskipta við Bandaríkin eða vegna viðskiptasambands við aðila með aðsetur í Bandaríkjunum<li>fasteigna í Bandaríkjunum (önnur en tilvikin sem lýst er hér að ofan) og/eða leiga þeirra<li>hlutabréfaeigna í bandarískum fasteignasjóðum</ul></li></ul>"
    }

    render() {
        const { customerId, initialValues, offers, nationalRegistry } = this.props
        // NOTE: the db in some cases has two identical entries. We are only interested in one of them
        // and we don't care which of them we use (in all cases they have the same riskgroup)
        let jobs = [...new Set(this.props.jobs.data.map(j => j.description))]

        return (
            <>
                <form className="contract-form">

                    <div className={`${this.state.errors.occupation.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="base-occupation" className="col-sm-8 col-form-label">
                            Starf
                            {this.state.errors.occupation.length > 0 ?
                                <span className="error"> ({this.state.errors.occupation}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            {jobs.length > 0 &&
                                <select ref={this.occupation} className="custom-select" id="base-occupation" name="occupation" onChange={this.onChangeSelectCustomerValue} value={this.props.initialValues.occupation} disabled={initialValues.taxInfoConfirm}>
                                    <option value="0">Veldu starf</option>
                                    {jobs.map(job => {
                                        return <option key={job} value={job}>{job}</option>
                                    })}
                                </select>
                            }
                        </div>
                    </div>

                    <div className={`${this.state.errors.cityOfBirth.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-cityOfBirth" className="col-sm-6 col-form-label">
                            Fæðingarstaður (borg)
                            {this.state.errors.cityOfBirth.length > 0 ?
                                <span className="error"> ({this.state.errors.cityOfBirth}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <input ref={this.cityOfBirth} id="addId-cityOfBirth" type="text" className="form-control text-right" name="cityOfBirth" placeholder="Sláðu inn fæðingarstað" onChange={this.onChangeTextInput} value={initialValues.cityOfBirth} disabled={initialValues.taxInfoConfirm} />
                        </div>
                    </div>

                    <div className="form-row align-items-center pb-4 pt-4">
                        <div className="col-sm-6 col-form-label">Ert þú með fleiri en einn ríkisborgararétt?</div>
                        <div className="col-sm-6 text-right smoker">
                            <input type="radio" id={`multipleCitizenships-no${this.props.insuranceTaker}`} name="multipleCitizenships" onClick={this.multipleCitizenshipsAnswerNo} defaultChecked={!initialValues.multipleCitizenships} value={false} disabled={initialValues.taxInfoConfirm} />
                            <label htmlFor={`multipleCitizenships-no${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Nei</label>
                            <input type="radio" id={`multipleCitizenships-yes${this.props.insuranceTaker}`} name="multipleCitizenships" onClick={this.onChangeCheckbox} defaultChecked={initialValues.multipleCitizenships} value={true} disabled={initialValues.taxInfoConfirm} />
                            <label htmlFor={`multipleCitizenships-yes${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Já</label>
                        </div>
                        {initialValues.multipleCitizenships &&
                            <>
                                <div className="col-sm-6 col-form-label">
                                    <strong>Vinsamlegast skráðu þau lönd þar sem þú ert með ríkisborgararétt (allt að þrjú)</strong>
                                    {initialValues.citizenships !== '' &&
                                        <>
                                            &nbsp;Núverandi skráning: {initialValues.citizenships}
                                        </>
                                    }
                                </div>
                                <div className="col-sm-6 text-right smoker">
                                    <button className="btn btn-primary" data-toggle="modal" data-target={`#CitizenshipModal-${this.props.insuranceTaker}`} onClick={(e) => e.preventDefault()}>{initialValues.citizenships !== '' ? 'Breyta' : 'Bæta við'}</button>
                                </div>
                            </>
                        }
                    </div>

                    <CitizenshipModal id={`CitizenshipModal-${this.props.insuranceTaker}`} store={this.props.store} insuranceTakerId={this.props.insuranceTaker} />

                    {!this.props.onlyRISLEB &&
                        <div className="form-row align-items-center">
                            <div className="col-sm-7 col-form-label">
                                {this.props.isFORorFORE
                                ?
                                <>Sérstök tenging tryggingartaka við Bandaríkin</>
                                :
                                <>Sérstök tenging við Bandaríkin</>                                
                                }
                                <Tooltip placement="bottom" text={this.usaTextContent()} />
                            </div>
                            <div className="col-sm-5 text-right smoker">
                                <input type="radio" id={`connectionUSA-no${this.props.insuranceTaker}`} name="connectionUSA" onChange={this.onChangeCheckbox} checked={!initialValues.connectionUSA} value={false} disabled={initialValues.taxInfoConfirm || initialValues.citizenUSA} />
                                <label htmlFor={`connectionUSA-no${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Nei</label>
                                <input type="radio" id={`connectionUSA-yes${this.props.insuranceTaker}`} name="connectionUSA" onChange={this.onChangeCheckbox} checked={initialValues.connectionUSA} value={true} disabled={initialValues.taxInfoConfirm || initialValues.citizenUSA} />
                                <label htmlFor={`connectionUSA-yes${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Já</label>
                                {initialValues.citizenUSA && <Tooltip placement="bottom" text={"<strong>Samkvæmt upplýsingum úr Þjóðskrá er tryggingartaki fæddur í BNA.</strong>"} />}
                            </div>
                        </div>
                    }
                    {initialValues.connectionUSA &&
                        (getPortfolios(this.props).indexOf('komfortdynamik') !== -1
                        ?(<Alert variant="warning">Ekki er hægt að velja ávöxtunarleiðina KomfortDynamik fyrir aðila með sérstaka tengingu við Bandaríkin.
                        Nánari upplýsingar eru á innri.allianz.is. Ef að viðskiptavinur vill skoða Perspektive getur þú farið til baka í <Link to={location => "/step/1" }>"Grunnupplýsingar"</Link></Alert>)
                        :(<div className={`${this.state.errors.tinOrSsn.length > 0 ? 'error' : ''} form-row align-items-center`}>
                            <label htmlFor="addId-tinOrSsn" className="col-sm-6 col-form-label">
                                SSN/TIN
                                {this.state.errors.tinOrSsn.length > 0 ?
                                    <span className="error"> ({this.state.errors.tinOrSsn}) </span> : ''
                                }
                            </label>
                            <div className="col-sm-4">
                                {initialValues.tinOrSsnSubmitLater ?
                                    <>Verður skilað síðar</>
                                    :
                                    <input ref={this.tinOrSsn} id="addId-tinOrSsn" type="text" className="form-control text-right" name="tinOrSsn" placeholder="Sláðu inn SSN eða TIN númer" onChange={this.onChangeTextInput} value={initialValues.tinOrSsn} disabled={initialValues.tinOrSsnSubmitLater || initialValues.taxInfoConfirm} />
                                }
                            </div>
                            <div className="col-sm-2">
                                <button type="button" className="btn btn-sm btn-warning" name="tinOrSsnSubmitLater" onClick={this.onClickSubmitLater} disabled={initialValues.taxInfoConfirm}>{initialValues.tinOrSsnSubmitLater ? "Skila núna" : "Skila síðar"}</button>
                            </div>
                         </div>)
                        )
                    }

                    {!this.props.onlyRISLEB && this.props.isFORorFORE &&
                        <div className="form-row align-items-center">
                            <div className="col-sm-7 col-form-label">
                                Sérstök tenging tryggingarþega við Bandaríkin
                                <Tooltip placement="bottom" text={this.usaTextContent()} />
                            </div>
                            <div className="col-sm-5 text-right smoker">
                                <input type="radio" id={`connectionToUSAInsured-no${this.props.insuranceTaker}`} name="connectionToUSAInsured" checked={!initialValues.connectionToUSAInsured} onChange={this.onChangeCheckbox} value={false} disabled={initialValues.taxInfoConfirm || nationalRegistry.BirthplaceCountryId == 'US'}/>
                                <label htmlFor={`connectionToUSAInsured-no${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Nei</label>
                                <input type="radio" id={`connectionToUSAInsured-yes${this.props.insuranceTaker}`} name="connectionToUSAInsured" checked={initialValues.connectionToUSAInsured} onChange={this.onChangeCheckbox} value={true} disabled={initialValues.taxInfoConfirm || nationalRegistry.BirthplaceCountryId == 'US'}/>
                                <label htmlFor={`connectionToUSAInsured-yes${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Já</label>
                                {nationalRegistry.BirthplaceCountryId == 'US' && <Tooltip placement="bottom" text={"<strong>Samkvæmt upplýsingum úr Þjóðskrá er tryggingarþegi fæddur í BNA.</strong>"} />}
                            </div>
                        </div>                        
                    }
                    {initialValues.connectionToUSAInsured &&
                        (getPortfolios(this.props).indexOf('komfortdynamik') !== -1
                        ?(<Alert variant="warning">Ekki er hægt að velja ávöxtunarleiðina KomfortDynamik fyrir aðila með sérstaka tengingu við Bandaríkin.
                        Nánari upplýsingar eru á innri.allianz.is. Ef að viðskiptavinur vill skoða Perspektive getur þú farið til baka í <Link to={location => "/step/1" }>"Grunnupplýsingar"</Link></Alert>)
                        :(<div className={`${this.state.errors.tinOrSsn.length > 0 ? 'error' : ''} form-row align-items-center`}>
                            <label htmlFor="addId-tinOrSsn" className="col-sm-6 col-form-label">
                                SSN/TIN
                                {this.state.errors.tinOrSsnInsured.length > 0 ?
                                    <span className="error"> ({this.state.errors.tinOrSsnInsured}) </span> : ''
                                }
                            </label>
                            <div className="col-sm-4">
                                {initialValues.tinOrSsnInsuredSubmitLater ?
                                    <>Verður skilað síðar</>
                                    :
                                    <input ref={this.tinOrSsnInsured} id="addId-tinOrSsnInsured" type="text" className="form-control text-right" name="tinOrSsnInsured" placeholder="Sláðu inn SSN eða TIN númer" onChange={this.onChangeTextInput} value={initialValues.tinOrSsnInsured} disabled={initialValues.tinOrSsnInsuredSubmitLater || initialValues.taxInfoConfirm} />
                                }
                            </div>
                            <div className="col-sm-2">
                                <button type="button" className="btn btn-sm btn-warning" name="tinOrSsnInsuredSubmitLater" onClick={this.onClickSubmitLater} disabled={initialValues.taxInfoConfirm}>{initialValues.tinOrSsnInsuredSubmitLater ? "Skila núna" : "Skila síðar"}</button>
                            </div>
                         </div>)
                        )
                    }
                    <div className="form-row align-items-center">
                        <div className="col-sm-7 col-form-label">
                            Er tryggingartaki, fjölskyldumeðlimur eða náinn samstarfsmaður hans, með stjórnmálaleg tengsl (PEP)
                        </div>
                        <div className="col-sm-5 text-right smoker">
                            <input type="radio" id={`politicalConnPolicyHolder-no${this.props.insuranceTaker}`} name="politicalConnPolicyHolder" checked={!initialValues.politicalConnPolicyHolder} onChange={this.onChangeCheckbox} value={false} disabled={initialValues.taxInfoConfirm}/>
                            <label htmlFor={`politicalConnPolicyHolder-no${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Nei</label>
                            <input type="radio" id={`politicalConnPolicyHolder-yes${this.props.insuranceTaker}`} name="politicalConnPolicyHolder" checked={initialValues.politicalConnPolicyHolder} onChange={this.onChangeCheckbox} value={true} disabled={initialValues.taxInfoConfirm}/>
                            <label htmlFor={`politicalConnPolicyHolder-yes${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Já</label>
                        </div>
                    </div>
                    {this.props.isFORorFORE && 
                    <div className="form-row align-items-center">
                        <div className="col-sm-7 col-form-label">
                            Er tryggingarþegi, fjölskyldumeðlimur eða náinn samstarfsmaður hans, með stjórnmálaleg tengsl (PEP)
                        </div>
                        <div className="col-sm-5 text-right smoker">
                            <input type="radio" id={`politicalConnInsured-no${this.props.insuranceTaker}`} name="politicalConnInsured" checked={!initialValues.politicalConnInsured} onChange={this.onChangeCheckbox} value={false} disabled={initialValues.taxInfoConfirm}/>
                            <label htmlFor={`politicalConnInsured-no${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Nei</label>
                            <input type="radio" id={`politicalConnInsured-yes${this.props.insuranceTaker}`} name="politicalConnInsured" checked={initialValues.politicalConnInsured} onChange={this.onChangeCheckbox} value={true} disabled={initialValues.taxInfoConfirm}/>
                            <label htmlFor={`politicalConnInsured-yes${this.props.insuranceTaker}`} className="col-sm-4 col-form-label">Já</label>
                        </div>
                    </div>
                    }
                </form>
                <div className="col-12 text-right button-container">
                    {initialValues.taxInfoConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="taxInfoConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="taxInfoConfirm" onClick={this.onClickConfirm} disabled={initialValues.connectionUSA && getPortfolios(this.props).indexOf('komfortdynamik') !== -1}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default TaxInfoCollection

TaxInfoCollection.defaultProps = {
    requirePhoto: false,
    successCallback: () => { },
    hasVID: false,
    onlyRISLEB: false,
    isFORorFORE:false,
}